import React from 'react';
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {SvgIcon} from "@mui/material";
import {lightBlue} from "@mui/material/colors";
import {ReactComponent as Boat} from "../../../svg/Blue/Boat.svg";

const CharterHead = ({ship}) => {
    const heroImg = ship.imageUrl;
    return (
        <div>
            <Container className="tripContainer">
                <div style={{
                    backgroundImage: `url("${heroImg}")`,
                    backgroundPositionY: 'center'
                }} className={'mainImage'}/>
                <div className="tripInfo">
                    <Grid container spacing={3} justify="space-between">

                        <Grid item xs>
                            <Typography component="h3" variant="h4" align="center">
                                <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <SvgIcon component={Boat} viewBox="0 0 50 50" sx={{
                                        stroke: lightBlue[500],
                                        fill: lightBlue[500],
                                        width: '35px',
                                        height: '30px',
                                        marginRight:'10px'
                                    }}/>
                                    {ship.location}
                                </span>
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    );
};

export default CharterHead;